import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Switch, Route, useRouteMatch, Link } from "react-router-dom";
import Swal from "sweetalert2";

import "./UserLoginForm.css";

const UserLoginForm = () => {
  let { path, url } = useRouteMatch();

  const [user, setUser] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const login = async (e) => {
    e.preventDefault();
    console.log("login");
    console.log(user);

    try {
      setLoading(true);
      const authResponse = await axios.post("/api/auth", user);
      const token = authResponse.headers["x-auth-token"];
      localStorage.setItem("token", token);
      localStorage.setItem(
        "firstName",
        authResponse.data.data ? authResponse.data.data.PrivateName : null
      );
      // console.log(authResponse.data.data);
      console.log(authResponse.data.path);
      history.replace(authResponse.data.path);
    } catch (error) {
      // alert(error.response.data.error);
      Swal.fire({
        title: "שגיאה",
        text: `${error.response.data.error}`,
        icon: "error",
        confirmButtonText: "סגירה",
      });
    } finally {
      setLoading(false);
    }
  };

  const onInputChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  return (
    <div id="main">
      <form id="userLoginForm" onSubmit={login}>
        <h2>כניסת צוות</h2>
        <div>
          <input
            className="input"
            onChange={onInputChange}
            type="text"
            value={user.username}
            name="username"
            id="username"
            placeholder="שם משתמש"
          />
        </div>
        <div>
          <input
            className="input"
            onChange={onInputChange}
            type="password"
            value={user.password}
            name="password"
            id="password"
            placeholder="סיסמה"
          />
        </div>
        <div>
          <input id="submit" type="submit" value="כניסה למערכת" />
        </div>
      </form>
      <div id="parentLogin">
        <Link to={`${url}/parents`}>למעבר לכניסת הורים</Link>
      </div>
    </div>
  );
};

export default UserLoginForm;
